import { render, staticRenderFns } from "./MyOverlay.vue?vue&type=template&id=89478572&scoped=true&"
import script from "./MyOverlay.vue?vue&type=script&lang=js&"
export * from "./MyOverlay.vue?vue&type=script&lang=js&"
import style0 from "./MyOverlay.vue?vue&type=style&index=0&lang=css&"
import style1 from "./MyOverlay.vue?vue&type=style&index=1&id=89478572&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89478572",
  null
  
)

export default component.exports